import React, { useEffect, useState } from 'react';
import './index.scss';
import Header  from '../../components/Header'; 
import { Outlet, Link, Navigate } from "react-router-dom";
import {Container,Row,Col,Button,Form} from 'react-bootstrap';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home  from '../Home';
import About  from '../About';
import Nopage from '../Nopage';
import Login from '../Login';
import Logout from '../Logout';
import Adduser from '../Adduser';
import Edituser from '../edituser';
import EditMember from '../EditMember';
import Register from '../Register';
import UserDelete from '../UserDelete';
import MemberDelete from '../MemberDelete';
import MSGDialogue from '../../components/Dialogue';
import {getCookie,rootUrl} from '../../App';
import Landing from '../Landing';
import Keys from '../Keys';
import AddKeys from '../AddKeys';
import Subscriptions from '../Subscriptions';
import Help from '../Help';
import EAAdd from '../AddEA';










function MenuBar(props){
    

    return(
<>
<div className="mx-2 mt-3 ">
<Link to={props.path} style={{textDecoration:'none'}}>
    <div onClick={() => props.action(props.id,props.path)} className={ props.active + ' menu-button button p-2 rounded text-center mr-2 ml-2'  }>
        <span className="position-relative float-left menu-icons ml-1 mr-2 "><i className={props.icon}></i></span>
        <span className='text-center menu-btn-text ' >{props.title}</span>
    </div>
    </Link>
</div>
</>
    );

}


function SideBar(){

    let login = true;

    var activated = (id,path)=>{
        let els =  document.getElementsByClassName("menu-button");

        for (let i=0; i<els.length-1;i++){
            els[i].classList.remove("btn-menu-active");
            els[i].classList.add("btn-menu-deactive");
        }
        els[id-1].classList.remove("btn-menu-deactive");
       els[id-1].classList.add("btn-menu-active");
       

       setTimeout(()=>{
        // eslint-disable-next-line no-restricted-globals
    if(screen.width<992){
        document.getElementsByClassName("side-panel")[0].classList.remove("expand-side");
        document.getElementsByClassName("side-panel")[0].classList.add("collapse-side");
    }

   },1000);
    
    // eslint-disable-next-line no-restricted-globals
   // location.href =rootUrl  + path;

    }

    var menulist = [];
    const userType = localStorage.getItem("userType");

    if (userType === "owner") {

  // show owner UI
  
    var menulist = [
        {id: 1, title:"Dashboard", icon:"fa fa-home", active:"btn-menu-active", path:"/dashboard"},
        {id: 2, title:"Add Mentor", icon:"fa fa-users", active:"btn-menu-deactive", path:"/register"},
        {id: 3, title:"Subscriptions ", icon:"fa fa-money", active:"btn-menu-deactive", path:"/subscriptions"},
        {id: 4, title:"License Keys", icon:"fa fa-lock", active:"btn-menu-deactive", path:"/keys"},
        {id: 5, title:"User/Clients", icon:"fa fa-user-o", active:"btn-menu-deactive", path:"/adduser"},
        {id: 6, title:"Find Help", icon:"fa fa-envelope", active:"btn-menu-deactive", path:"/Help"}
    ];
}
else{
     var menulist = [
        {id: 1, title:"Dashboard", icon:"fa fa-home", active:"btn-menu-active", path:"/dashboard"},
        {id: 2, title:"License Keys", icon:"fa fa-lock", active:"btn-menu-deactive", path:"/keys"},
        {id: 3, title:"User/Clients", icon:"fa fa-user-o", active:"btn-menu-deactive", path:"/adduser"},
        {id: 4, title:"Find Help", icon:"fa fa-envelope", active:"btn-menu-deactive", path:"/Help"}
    ];
    
}

    var close = ()=>{

        // eslint-disable-next-line no-restricted-globals
        if(screen.width<992){

            document.getElementsByClassName("side-panel")[0].classList.remove("expand-side");

            document.getElementsByClassName("side-panel")[0].classList.add("collapse-side");

        }
     
    }
   
    if(login){

        return (<>
        <div className="side-panel h-100 p-0 expand-side p-hide transition-all-1s" >
                <div className='text-danger float-right d-hide close-side-panel mb-2 mr-2' onClick={close}><i className='fa fa-close text-danger'></i></div>
                <br />
                {menulist.map((button) => <MenuBar key={button.id}  id={button.id} action={activated} title={button.title} active={button.active}
                 icon ={button.icon}   path ={button.path}  />)}
                 <hr />
                 <br>
                 </br>
                 <div className="logout-button mt-4">
                    <MenuBar title="Sign in"  id="9" active="btn-menu-deactive" action={activated} icon="fa fa-arrow-circle-o-right" path = "login" />
                 </div>
                 <div className="logout-button mt-1 ">
                    <MenuBar title="logout" active="btn-menu-active" icon="fa fa-arrow-circle-o-right" path = "logout" />
                 </div>
                
              

            </div>
        
        </>)
    }
    else{
        <Navigate to='/test'  />
    }
}




export default function Layout(){

var auth = false;

 if(getCookie("eatradeuser") != null){
    var auth = true;
 }

    var close = ()=>{

       
        // eslint-disable-next-line no-restricted-globals
        if(screen.width<992){
            document.getElementsByClassName("side-panel")[0].classList.remove("expand-side");
            document.getElementsByClassName("side-panel")[0].classList.add("collapse-side");
        }
      
   
    };
    if(auth){
        
    return (
        <><BrowserRouter>
           
            <Header />
            <MSGDialogue msg = "You are already logged in" id = "msg2"  colors= " text-white bg-success" />
            <Container fluid className='layout p-0'>
            <SideBar />
                <div className="container-fluid m-0 p-2" onClick={close}>
                    <Routes> 
                        <Route index element={<Home />}/>
                        <Route path="/" element={<Home />}/>
                        <Route path="/dashboard" element={<Home />}/>
                        <Route path="/keys" element={<Keys />}/>
                        <Route path="keys/addkey" element={<AddKeys />}/>
                        <Route path="/Help" element={<Help />}/>
                        <Route path="/about" element={<About />}/>
                        <Route path="/addea" element={<EAAdd />}/>
                        <Route path="/dashboard/addea" element={<EAAdd />}/>
                        <Route path="/landing" element={<Landing />}/>
                        <Route path="/subscriptions" element={<Subscriptions />}/>
                        <Route path="/login" element={<Login />}/>
                        <Route path="/logout" element={<Logout />}/>
                        <Route path="/adduser" element={<Adduser />}/>
                        <Route path="dashboard/adduser" element={<Adduser />}/>
                        <Route path="/adduser/edituser" element={<Edituser/>}/>
                        <Route path="/register" element={<Register />}/>
                        <Route path="/editmember" element={<EditMember />}/>
                        <Route path="/dashboard/register" element={<Register />}/>
                        <Route path="/userdelete" element={<UserDelete />}/>
                        <Route path="/memberdelete" element={<MemberDelete />}/>
                        <Route path="*" element={<Nopage />}/>
                    </Routes>
            </div>
</Container> 
        </BrowserRouter><Outlet /></>
        
    );

    }
    else{
        return (
        <><BrowserRouter>
           
            <Header />
            <Container fluid className='layout p-0'>
         
                <div className="container-fluid m-0 p-2" >
                    <Routes> 
                    <Route index element={<Landing />}/>
                     <Route path="/login" element={<Login />}/>
                    <Route path="*" element={<Nopage />}/>
                    </Routes>
            </div>
</Container> 
        </BrowserRouter><Outlet /></> );
    }
}